

import React from "react";

import error500 from "../../assets/500.png";

import "./ErrorPage.scss";

class ErrorPage extends React.Component<unknown> {
  render() {
    return (
      <div className="text-center mt-5 pt-5">
        <div className=" mt-3 col-xs-12 col-md-4 offset-md-4 img-wrapper">
          <div
            className="position-relative text-center img-inner"
            style={{ zIndex: 50 }}
          >
            <img
              className="img-fluid"
              alt="error"
              src={error500}
              style={{ height: "16rem" }}
            />
            <div id="smoke">
              <span className="s0" />
              <span className="s1" />
              <span className="s2" />
              <span className="s3" />
              <span className="s4" />
              <span className="s5" />
              <span className="s6" />
              <span className="s7" />
              <span className="s8" />
              <span className="s9" />
            </div>
          </div>
        </div>

        <p className="mt-3 px-3 text-primary h5">
                    Si è verificato un imprevisto.
          <br />
          <span className=""> Niente paura! </span>
          <br />I nostri dottori del software sono già stati informati
                    e stanno provvedendo a risolvere il problema.{" "}
        </p>
      </div>
    );
  }
}

export default ErrorPage;
